import Cookies from 'js-cookie';

// Guard cookies ของ portal — SPA route ตามค่าพวกนี้ (router.js, Login.vue, NavBar.vue)
// ต้องตรงกับ PortalSessionCookies.Names ใน WebAPI/Authen/PortalSessionCookies.cs ที่ backend ออกหลัง login ถัง admin
export const GUARD_COOKIE_NAMES = Object.freeze([
  'authenticated',
  'userId',
  'username',
  'fullName',
  'roleId',
  'companyId',
  'companyName',
  'userType',
  'isSuperAdmin',
  'isUserChat',
  'loginProvider',
]);

// JS cookie ของ widget เอง (chat SSO → RedirectFromLogin.vue) — ลบได้ในหน้า widget
export const SNIPPET_COOKIE_NAMES = Object.freeze(['token_Snippet', 'username_Snippet', 'email_Snippet', 'isSnippet']);

/**
 * Options สำหรับเขียน guard cookies: SameSite=Lax (+Secure บน https) เหมือนที่ backend ออก
 * portal เป็น first-party เสมอ (SPA กับ API origin เดียวกันทุก env) จึงไม่ต้องใช้ None และ Lax ทำให้ iframe
 * ข้าม site (widget บนเว็บลูกค้า) อ่านไม่เห็น — เดิมเขียนเป็น None เพื่อให้ widget ยืม session ของ portal
 * ซึ่งเป็นต้นเหตุ loop /login ↔ /dashboard ใน iframe (docs/features/chat-fullstream/32-admin-snippet-cookie-split-plan.md)
 */
export function portalCookieOpts() {
  return globalThis.location?.protocol === 'https:' ? { sameSite: 'Lax', secure: true } : { sameSite: 'Lax' };
}

export function isEmbeddedInIframe() {
  try {
    return globalThis.self !== globalThis.top;
  } catch {
    return true;
  }
}

/** หน้านี้เปิดโดย loader ของ widget — SmallV2 / FullV2 ใส่ snippet=true ใน src ของ iframe เสมอ */
export function isSnippetPage() {
  try {
    for (const [key, value] of new URLSearchParams(globalThis.location?.search || '')) {
      if (key.toLowerCase() === 'snippet') return value === 'true';
    }
  } catch {
    // intentionally ignored: URL อ่านไม่ได้ = ไม่ใช่หน้า widget
  }
  return false;
}

/**
 * บริบทที่ห้ามพาไปหน้า portal (/login, /dashboard): หน้า widget หรือหน้าใด ๆ ที่ถูกฝังใน iframe
 * ใน iframe ข้าม site JS ลบ guard cookies แบบ None ของ portal ไม่ได้ (Cookies.remove เป็น no-op)
 * /login จึงยังเห็น authenticated=true แล้วดันเข้า portal → 401 → กลับ /login ไม่รู้จบ
 */
export function isSnippetContext() {
  return isSnippetPage() || isEmbeddedInIframe();
}

/**
 * อ่าน guard cookie — หน้า widget คืน undefined เสมอ เพราะ cookie พวกนี้เป็นของ portal ที่ login อยู่ใน browser
 * เดียวกัน ไม่ใช่ของคนที่ใช้ widget (สถานะ login ของ widget อยู่ใน sessionStorage + access_token_snippet)
 */
export function getPortalCookie(name) {
  return isSnippetPage() ? undefined : Cookies.get(name);
}

export function removeGuardCookies() {
  for (const name of GUARD_COOKIE_NAMES) {
    Cookies.remove(name);
  }
}
